export const checkModelIsNotOther = (model: string): boolean => !model.includes('Other');

export const checkMakeIsNotOther = (make: string): boolean => make.toLocaleLowerCase() !== 'other';
